<template>
    <div>
        <div class="alert alert-danger d-flex justify-content-between" 
            v-if="value 
                && value.paciente_unidade.st_lembrete 
                && ( !value.paciente_unidade.dt_valid_lembrete || value.paciente_unidade.dt_valid_lembrete >= $util.hoje() )">
                
            <div class="lead">
                <i class="fas fa-thumbtack mr-2"></i>
                {{ value.paciente_unidade.st_lembrete }}
            </div>
            <div v-if="value.paciente_unidade.dt_valid_lembrete" class="small text-muted">
                <i class="fas fa-less-than mr-1"></i>
                {{ $util.getFormatDate(value.paciente_unidade.dt_valid_lembrete) }}
            </div>
        </div>

        <div class="alert alert-danger d-flex justify-content-between" 
            v-if="value 
                && value.paciente_unidade.st_lembrete_assistencia
                && ( !value.paciente_unidade.dt_valid_lembrete_assist || value.paciente_unidade.dt_valid_lembrete_assist >= $util.hoje())">

            <div class="lead">
                <i class="fas fa-thumbtack mr-2"></i>
                <i class="fas fa-file-medical mr-2"></i>
                {{ value.paciente_unidade.st_lembrete_assistencia }}
            </div>
            <div v-if="value.paciente_unidade.dt_valid_lembrete_assist" class="small text-muted">
                <i class="fas fa-less-than mr-1"></i>
                {{ $util.getFormatDate(value.paciente_unidade.dt_valid_lembrete_assist) }}
            </div>

        </div>

        <div class="d-flex justify-content-end" v-if="1 == 0">
            <button type="button" class="btn btn-outline-secondary btn-sm mb-2" data-toggle="tooltip" data-placement="top" title="Lembrete do Paciente"
                @click="editar ()">
                <i class="fas fa-thumbtack mr-2"></i> Paciente
            </button>
        </div>

        <div
            class="modal fade"
            :id="nome_modal"
            tabindex="-1"
            role="dialog"
            aria-labelledby="modelTitleId"
            aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Lembrete do Paciente</h5>
                        <button type="button" class="close" @click="fechar ()" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <template v-if="tipo == 'G'">
                            <az-input 
                                type="textarea" 
                                v-model="st_lembrete" 
                                :validate="validate" />

                            <az-input
                                class="mt-2"
                                sizing="sm"
                                type="date"
                                label="Validade (Opcional)"
                                v-model="dt_valid_lembrete" />
                        </template>

                        <template v-if="tipo == 'A'">
                            <az-input 
                                type="textarea" 
                                v-model="st_lembrete_assistencia" 
                                :validate="validate" />

                            <az-input
                                type="date"
                                label="Validade (Opcional)"
                                v-model="dt_valid_lembrete_assist" />
                        </template>


                        <div v-if="tem_lembrete_assistencia" class="mt-3 d-flex flex-column">
                            <az-input
                                sizing="sm"
                                type="button-group"
                                :optionsList="[
                                    { id: 'A', search: 'Para Assistência' },
                                    { id: 'G', search: 'Geral' }
                                ]" 
                                optionsData="id"
                                v-model="tipo" />
                        </div>

                        <div class="row mt-3">
                            <div class="col col-12">
                                <small class="text-muted">Classificação</small>
                                <multiselect
                                    v-model="classes"
                                    :options="options_classes"
                                    :multiple="true"
                                    :taggable="true"
                                    @tag="addTag"
                                    placeholder="Selecione uma classificação..."
                                    selectLabel="Pressione [ENTER] para selecionar"
                                    deselectLabel="Pressione [ENTER] para remover"
                                    tagPlaceholder="Pressione [ENTER] para incluir"
                                    selectedLabel="Selecionado">
                                    <template slot="noOptions">
                                        Nenhuma classificação registrada.
                                    </template>
                                </multiselect>
                            </div>
                        </div>

                        <br><br><br><br><br><br><br><br><br><br>
                    </div>

                    <div class="modal-footer">
                        <az-audit-log-button 
                            model="pacienteUnidade" 
                            :id="value.paciente_unidade.id_paciente_unidade" 
                            :campos="( $store.state.user && $store.state.user.medico ) ? { st_lembrete: true, st_lembrete_assistencia: true } : { st_lembrete: true }"
                            v-if="value && value.paciente_unidade" />

                        <az-submit color="outline-danger" v-if="preenchido" @click="removerLembrete ()">Remover</az-submit>
                        <button type="button" class="btn btn-secondary" @click="fechar ()">Fechar</button>
                        <az-submit @click="atualizar ()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import Multiselect from 'vue-multiselect';

export default {
    data () { 
        return { 
            st_lembrete: null, 
            st_lembrete_assistencia: null,
            tipo: 'G', 
            validate: false, 
            options_classes: [], 
            classes: [], 
            dt_valid_lembrete: "", 
            dt_valid_lembrete_assist: "", 
            chave_modal: "", 
        }
    },

    components: { 
        AzInput,
        AzSubmit,
        AzAuditLogButton, 
        Multiselect, 
    },

    props: ['value'],

    computed: { 
        tem_lembrete_assistencia: function () { 
            if ( !this.value || !this.value.paciente_unidade )
                return false;

            return _.keys(this.value.paciente_unidade).find(item => item == 'st_lembrete_assistencia') ? true : false;
        },

        preenchido: function () { 
            if ( !this.value || !this.value.paciente_unidade )
                return false;

            return this.tipo == 'A' ? this.value.paciente_unidade.st_lembrete_assistencia : this.value.paciente_unidade.st_lembrete;
        },

        nome_modal: function () { 
            return 'lembretePacienteModal_' + this.chave_modal;
        }
    },

    methods: { 
        addTag (newTag) {
            this.options_classes.push(newTag);

            if ( !this.classes )
                this.classes = [];

            this.classes.push(newTag);
        },

        removerLembrete () { 

            this.$util.atualizar (this, { 
                service: 'pacientes',
                func: 'lembrete', 
                dados: { 
                    id_paciente: this.value.id_pessoa,
                    tipo: this.tipo, 
                    remover: true
                },
                modal: this.nome_modal,
                callback: () => { 
                    if ( this.tipo == 'A' ) { 
                        this.value.paciente_unidade.st_lembrete_assistencia = null;    
                    } else { 
                        this.value.paciente_unidade.st_lembrete = null;
                    }

                    this.$emit('input', this.value);
                }
            });

        },

        atualizar () { 

            this.$util.atualizar (this, { 
                service: 'pacientes',
                func: 'lembrete', 
                dados: { 
                    id_paciente: this.value.id_pessoa,
                    st_lembrete: this.st_lembrete,
                    st_lembrete_assistencia: this.st_lembrete_assistencia, 
                    dt_valid_lembrete: this.dt_valid_lembrete,
                    dt_valid_lembrete_assist: this.dt_valid_lembrete_assist,
                    tipo: this.tipo, 
                    classes: this.classes, 
                },
                modal: this.nome_modal,
                callback: res => { 
                    if ( this.tipo == 'A' ) { 
                        this.value.paciente_unidade.st_lembrete_assistencia = res;
                        this.value.paciente_unidade.dt_valid_lembrete_assist = this.dt_valid_lembrete_assist;
                    } else { 
                        this.value.paciente_unidade.st_lembrete = res;
                        this.value.paciente_unidade.dt_valid_lembrete = this.dt_valid_lembrete;
                    }

                    this.value.paciente_unidade.js_classes = this.classes;

                    this.$emit('input', this.value);
                }
            });

        },

        fechar () { 
            $('#' + this.nome_modal).modal('hide');
        },

        editar () { 
            this.validate = false;
            this.st_lembrete = this.value.paciente_unidade.st_lembrete;
            this.st_lembrete_assistencia = this.value.paciente_unidade.st_lembrete_assistencia;
            this.dt_valid_lembrete = this.value.paciente_unidade.dt_valid_lembrete;
            this.dt_valid_lembrete_assist = this.value.paciente_unidade.dt_valid_lembrete_assist;
            this.classes = _.cloneDeep(this.value.paciente_unidade.js_classes);

            this.tipo = ( this.tem_lembrete_assistencia && 
                ( this.value.paciente_unidade.st_lembrete_assistencia || 
                    !this.value.paciente_unidade.st_lembrete ) ) ? 'A' : 'G';

            $('#' + this.nome_modal).modal('show');
        }
    },

    beforeMount() { 
        this.chave_modal = this.$util.uuidv4(); 
    }, 

    updated() {
      $('[data-toggle="tooltip"]').tooltip();
    }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>